import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { VendersFilterEntity } from '../../domain/entities/VendersFilterEntity'

export class VendersFilterModel extends VendersFilterEntity {
  constructor(dataDto: VendersFilterEntity) {
    super()
    mapEntityProperties<VendersFilterModel>(this, dataDto)
  }
}
